<app-navbar title="Wycieczki fakultatywne">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-dynamic-table module="optionalTrip" [elements]="data" [tableRows]="tableRows"></app-dynamic-table>
